import Vue from 'vue';
import Vuex from 'vuex';
import api from '../api';
import { unionPermissions } from '../router/permissions.cjs';
Vue.use(Vuex);
const token = sessionStorage.getItem('sas_token');
const demo = sessionStorage.getItem('sas_demo') === '1';
export default new Vuex.Store({
  state: { token, actor: demo ? api.demoActor : null, demo, loading: false },
  getters: { permissions: (state) => unionPermissions(state.actor || {}), isDemo: (state) => state.demo },
  mutations: {
    setSession(state, { token: value, actor, demo }) { state.token = value || null; state.actor = actor || null; state.demo = !!demo; if (value) sessionStorage.setItem('sas_token', value); else sessionStorage.removeItem('sas_token'); sessionStorage.setItem('sas_demo', demo ? '1' : '0'); },
    clearSession(state) { state.token = null; state.actor = null; state.demo = false; sessionStorage.removeItem('sas_token'); sessionStorage.removeItem('sas_demo'); },
    setLoading(state, value) { state.loading = value; }
  },
  actions: {
    async login({ commit }, credentials) { commit('setLoading', true); try { const result = credentials.demo ? { token: 'demo-readonly', user: api.demoActor } : await api.login(credentials); commit('setSession', { token: result.token, actor: result.user || result.actor, demo: !!credentials.demo }); return result; } finally { commit('setLoading', false); } },
    async refreshMe({ commit, state }) { if (!state.token || state.demo) return state.actor; const actor = await api.me(); commit('setSession', { token: state.token, actor: actor.user || actor.actor || actor, demo: false }); return actor; },
    async logout({ commit }) { try { await api.logout(); } finally { commit('clearSession'); } }
  }
});
